import ScoreScreen from './ScoreScreen';

export default ScoreScreen;
